import Fuzzy from "@leeoniya/ufuzzy"

export const ProductInformationComponentsAPIType = "components" as const
export const ProductInformationTypename = "ProductInformation" as const
export const ProductAttributeTypename = "ProductAttribute" as const
export const ProductInformationTextFieldTypename =
  "ProductInformationTextField" as const

export const PRODUCT_SEARCH_OPTIONS: Fuzzy.Options = {
  interIns: 1,
  intraMode: 1
}
